import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import New from '../views/New.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/download'),
    meta: {
      title: 'LianBa'
    }
  },
  {
    path: '/useVideo',
    name: 'useVideo',
    component: () => import('../views/useVideo'),
    meta: {
      title: '使用视频'
    }
  },
  {
    path: '/useDirection',
    name: 'useDirection',
    component: () => import('../views/useDirection'),
    meta: {
      title: '使用说明'
    }
  },
  {
    path: '/productIndex',
    name: 'productIndex',
    component: () => import('../views/productIndex'),
    meta: {
      title: '产品介绍'
    }
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: () => import('../views/productDetail'),
    meta: {
      title: '产品描述'
    }
  },
  {
    path: '/productDirection',
    name: 'productDirection',
    component: () => import('../views/productDirection'),
    meta: {
      title: '安麟产品说明'
    }
  },
  {
    path: '/videoDetail',
    name: 'videoDetail',
    component: () => import('../views/videoDetail'),
    meta: {
      title: '视频说明'
    }
  },
  {
    path: '/directionsDetail',
    name: 'directionsDetail',
    component: () => import('../views/directionsDetail'),
    meta: {
      title: '图文说明'
    }
  },
  {
    path: '/New',
    component: New,
    name: 'New'
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
